module.exports = [{"type":"title","text":"2024-06-28"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續新增接口：查詢歷史成交明細"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-06-28.json
// module id = khDw
// module chunks = 3